// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ResetDeclarationModal__wrap--J9HSB"};